import React from 'react'
import {
  Modal,
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  Stack,
  Divider,
} from '@mui/material'

interface SearchItem {
  id: string
  label: string
  created_at: string
}

interface SearchModalProps {
  isOpen: boolean
  onClose: () => void
  items: SearchItem[]
  onItemSelect: (id: string) => void
  formatDate?: (date: string) => string
}

export const SearchModal: React.FC<SearchModalProps> = ({
  isOpen,
  onClose,
  items,
  onItemSelect,
  formatDate = (date) => new Date(date).toLocaleString('ja-JP'),
}) => {
  const [searchQuery, setSearchQuery] = React.useState('')

  // 検索フィルタリング
  const filteredItems = React.useMemo(() => {
    if (!searchQuery) {
      return items
    }
    return items.filter((item) =>
      item.label.toLowerCase().includes(searchQuery.toLowerCase())
    )
  }, [searchQuery, items])

  const handleItemClick = (id: string) => {
    onItemSelect(id)
    onClose()
    setSearchQuery('') // モーダルを閉じる時に検索をリセット
  }

  return (
    <Modal open={isOpen} onClose={onClose} sx={{ zIndex: 1303 }}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '70%', md: '50%' },
          height: '60vh',
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* 検索入力欄 */}
        <TextField
          autoFocus
          fullWidth
          placeholder="ラベルから検索"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ mb: 2 }}
        />

        {/* 検索結果リスト */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
          }}
        >
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {filteredItems.map((item, index) => (
              <React.Fragment key={item.id}>
                <ListItem
                  component="li"
                  onClick={() => handleItemClick(item.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box>
                      <ListItemText primary={item.label} />
                    </Box>
                    <Box>
                      <ListItemText primary={formatDate(item.created_at)} />
                    </Box>
                  </Stack>
                </ListItem>
                {index < filteredItems.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Box>
    </Modal>
  )
}
